export const BusMainTypeEnum = {
  EXPRESS: 'ARRIVA EXPRESS',
  LONG_DISTANCE: 'Dálkové autobusy',
  REGION: 'Regionální BUS',
  MHD: 'MHD'
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Map/BusMainTypeEnum.js